Apt.fn.make('videos.entry', {
	/**
	 * Initialize module
	 */
	init: function() {
		var $related = $$('related');

		if (! $related.length) {
			return;
		}

		var ids = $related.data('id');

		$.fetch.request({
			url: '/api/v1/catalog',
			data: {
				id: ids
			},
			json: true,
			success: function(response) {
				if (! response.data || response.data.length !== 4) {
					return;
				}

				$$('relatedProducts').html(
					$.view.render('catalog.results', {
						results: response.data,
						modifier: 'wide'
					})
				);

				$related.show();

				Apt.wishlists.highlight();
				Apt.wishlists.bind('video', 'ref:relatedProducts');
			}
		});
	},

	/**
	 * Unload module
	 */
	unload: function() {
		$.events.reset('video');
	}
});